import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RoleDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RoleEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/role"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/role/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/role/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/role/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/role/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/role/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/role/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RoleFormFields extends Array<IFieldOptions> {
	public selected: IFieldOptions = { field: "selected" };
	public organisation: IFieldOptions = { field: "organisation" };
	public id: IFieldOptions = { field: "id" };
	public organisationId: IFieldOptions = { field: "organisationId" };
	public concurrencyStamp: IFieldOptions = { field: "concurrencyStamp" };
	public name: IFieldOptions = { field: "name" };
	public normalizedName: IFieldOptions = { field: "normalizedName" };
	public description: IFieldOptions = { field: "description" };
	public changedBy: IFieldOptions = { field: "changedBy" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public status: IFieldOptions = { field: "status" };
	constructor() {
		super();
		this.push(this.selected);
		this.push(this.organisation);
		this.push(this.id);
		this.push(this.organisationId);
		this.push(this.concurrencyStamp);
		this.push(this.name);
		this.push(this.normalizedName);
		this.push(this.description);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class RoleForm implements IFormOptions {
	protected roleFormName: string = "roleForm";
	protected roleFormModel: models.RoleDTO = new models.RoleDTO();
	protected roleFormEndPoints: RoleEndPoints = new RoleEndPoints();
	protected roleFormFields: RoleFormFields = new RoleFormFields();
	public get name(): string { return this.roleFormName };
	public get model(): models.RoleDTO { return this.roleFormModel };
	public get endPoints(): IEntityEndPoints { return this.roleFormEndPoints };
       public set endPoints(roleEndPoints: IEntityEndPoints) {
		this.roleFormEndPoints = roleEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RoleFormFields { return this.roleFormFields };
}

export class RoleListColumns extends Array<IColumnOptions> {
	public selected: IColumnOptions = { field: "selected" };
	public organisation: IColumnOptions = { field: "organisation" };
	public id: IColumnOptions = { field: "id" };
	public organisationId: IColumnOptions = { field: "organisationId" };
	public concurrencyStamp: IColumnOptions = { field: "concurrencyStamp" };
	public name: IColumnOptions = { field: "name" };
	public normalizedName: IColumnOptions = { field: "normalizedName" };
	public description: IColumnOptions = { field: "description" };
	public changedBy: IColumnOptions = { field: "changedBy" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public status: IColumnOptions = { field: "status" };
	constructor() {
		super();
		this.push(this.selected);
		this.push(this.organisation);
		this.push(this.id);
		this.push(this.organisationId);
		this.push(this.concurrencyStamp);
		this.push(this.name);
		this.push(this.normalizedName);
		this.push(this.description);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class RoleList implements IGridOptions {
	protected roleListName: string = "roleList";
	protected roleListModel: models.RoleDTO = new models.RoleDTO();
	protected roleListEndPoints: RoleEndPoints = new RoleEndPoints();
	protected roleListColumns: RoleListColumns = new RoleListColumns();
	public roleForm: RoleForm = new RoleForm();
	public get name(): string { return this.roleListName };
	public get model(): models.RoleDTO { return this.roleListModel };
	public get endPoints(): IEntityEndPoints { return this.roleListEndPoints };
	public set endPoints(roleEndPoints: IEntityEndPoints) {
		this.roleListEndPoints = roleEndPoints;
		this.roleForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RoleListColumns { return this.roleListColumns };
}

export class RoleEntity implements IEntityOptions {
	protected roleEntityName: string = "roleEntity";
	protected roleEntityModel: models.RoleDTO = new models.RoleDTO();
	protected roleEntityEndPoints: RoleEndPoints = new RoleEndPoints();
	protected roleEntityList: RoleList = new RoleList();
	public get name(): string { return this.roleEntityName };
	public get model(): models.RoleDTO { return this.roleEntityModel };
	public get endPoints(): IEntityEndPoints { return this.roleEntityEndPoints };
	public set endPoints(roleEndPoints: IEntityEndPoints) {
		this.roleEntityEndPoints = roleEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RoleList { return this.roleEntityList };
	public get form(): RoleForm { return this.grid.roleForm };
	constructor(name?: string) {
		if (name) this.roleEntityName = name;
		this.endPoints = this.roleEntityEndPoints;
	}
};
//export class RoleGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RoleForm = new RoleForm();
//};

//export class RoleListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RoleList = new  RoleList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class RoleBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RoleGeneratedForm}];
//};

//export class RoleListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RoleListPageComponent, isMenuHidden: true }];
//};

